import axios from 'axios'

export default {
    namespaced: true,
    state: {
        notifications: [],
        messageNotifications: [],
        voicemailNotifications: [],
    },
    mutations: {
        SET_NOTIFICATIONS(state, notifications) {
            state.notifications = notifications;
        },
        SET_MESSAGE_NOTIFICATIONS(state, notifications) {
            state.messageNotifications = notifications;
        },
        UPDATE_MESSAGE_NOTIFICATION(state, id) {
            state.notifications = state.notifications.filter(n => (n.id !== id && n.type === 'message') || n.type !== 'message');
            state.messageNotifications = state.messageNotifications.filter(n => n.id !== id);
        },
        SET_VOICEMAILS_NOTIFICATIONS(state, notifications) {
            state.voicemailNotifications = notifications;
        },
        UPDATE_VOICEMAILS_NOTIFICATION(state, id) {
            state.notifications = state.notifications.filter(n => (n.id !== id && n.type === 'voicemail') || n.type !== 'voicemail');
            state.voicemailNotifications = state.voicemailNotifications.filter(n => n.id !== id);
        }
    },
    getters: {
        notifications: state => state.notifications,
        messageNotifications: state => state.messageNotifications,
        voicemailNotifications: state => state.voicemailNotifications,
    },
    actions: {
        loadNotifications({ commit }, user_id) {
            axios.get("/notifications/user/" + user_id).then(res => {
                commit("SET_NOTIFICATIONS", res.data.notifications);
            }).catch(e => {
                console.log(e);
            });
        },
        loadMessageNotifications({ commit }, { user_id, lead_id }) {
            axios.get("notifications/messages/user/" + user_id + "/lead/" + lead_id)
                .then(res => {
                    commit("SET_MESSAGE_NOTIFICATIONS", res.data.notifications);
                }).catch(e => {
                    console.log(e);
            });
        },
        loadVoicemailsNotifications({ commit }, { user_id, lead_id }) {
            axios.get("notifications/voicemails/user/" + user_id + "/lead/" + lead_id)
                .then(res => {
                    commit("SET_VOICEMAILS_NOTIFICATIONS", res.data.notifications);
                }).catch(e => {
                console.log(e);
            });
        },
        updateMessageNotification({ commit }, message_id) {
            axios.post("/notifications/messages/update", {
                message_id: message_id
            }).then(() => {
                if (message_id) {
                    commit("UPDATE_MESSAGE_NOTIFICATION", message_id);
                }
            }).catch(e => {
                console.log(e);
            });
        },
        updateVoicemailNotification({ commit }, voicemail_id) {
            axios.post("/notifications/voicemails/update", {
                voicemail_id: voicemail_id
            }).then(() => {
                if (voicemail_id) {
                    commit("UPDATE_VOICEMAILS_NOTIFICATION", voicemail_id);
                }
            }).catch(e => {
                console.log(e);
            });
        },
    }
}